// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { FastenerCollectionModel } from "@store/Framework/Types/ApiModels";
import { FastenersState } from "@store/Framework/Store/Store/Data/Fasteners/FastenersState";
import { Draft } from "immer";

const initialState: FastenersState = {
    lengthCollection: [],
    boxCountCollection: [],
    headDiameterCollection: [],
    threadCollection: [],
    driveTypeCollection: [],
    pointCollection: [],
    headCollection: [],
    finishCollection: [],
};

const actions = {
    "Store/Data/Fasteners/CompleteLoadFastenersCollections": (
        draft: Draft<FastenersState>,
        action: { collection: FastenerCollectionModel },
    ) => {
        draft.lengthCollection = action.collection.lengthCollection ?? [];
        draft.boxCountCollection = action.collection.boxCountCollection ?? [];
        draft.headDiameterCollection = action.collection.headDiameterCollection ?? [];
        draft.threadCollection = action.collection.threadCollection ?? [];
        draft.driveTypeCollection = action.collection.driveTypeCollection ?? [];
        draft.pointCollection = action.collection.pointCollection ?? [];
        draft.headCollection = action.collection.headCollection ?? [];
        draft.finishCollection = action.collection.finishCollection ?? [];
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type FastenersActions = Parameters<typeof reducer>[1];
export default reducer;
